import { ShowReport } from "components/reports/show";
import { viewContainer } from "helpers/redux";
import { REPORT_TYPES } from "helpers/reports";
import React from "react";

const ConfiguredPlanFactOverallReport = (props) => (
    <div className="page-content">
        <ShowReport {...props} id={REPORT_TYPES.PlanFactOverallReport} transition="full" />
    </div>
);

export default viewContainer(ConfiguredPlanFactOverallReport, "reports");
